import { PlacesAnalyticsCoreEventBase } from './placesAnalyticsCoreEventBase';
import { PlacesMarkerTimeout } from './constants';
import { PerformanceCoreDatapoint } from 'owa-analytics';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * These strings are expensive to store in kusto. keeping it short.
 * This list is the source of truth.
 */
export const STEP_TO_WATERFALL_INDEX_MAP = {
    BootstrapCompleted: 1, // Completion of Places bootstrap (initializeState)
    PlacesSettingsFetched: 2, // Successful fetching of Places Settings
    RBACSettingsFetched: 3, // Successful fetching of RBAC Settings
    AnalyticsRootLoadBegin: 4, // HybridSpace Analytics component render initiated
    LatestReportDateFetched: 5, // Successful fetching of Latest Report Date
    BuildingIdSettingsFetched: 6, // Successful fetching of Building Ids from Places Settings
    BuildingsFetched: 7, // Successful fetching of Buildings
    RoomCountFetched: 8, // Successful fetching of Room Count
    DeskPoolCountFetched: 9, // Successful fetching of DeskPool Count
    TabLoadBegin: 10, // Tab page component render initiated (eg: HomePage, Room/Building/Deskpool page)
    TabLoadEnd: 11, // Tab page loaded
} as const;

/**
 * Measures from the beginning of the Places bootstrap (initializeState) in the owa-shared-bootstrap and ends on completion of home page load
 */
class PlacesAnalyticsAppLoadE2E extends PlacesAnalyticsCoreEventBase<
    typeof STEP_TO_WATERFALL_INDEX_MAP
> {
    constructor() {
        super(true);
    }

    protected createNewPerformanceCoreDatapoint(): PerformanceCoreDatapoint {
        return new PerformanceCoreDatapoint(
            'PlacesAnalyticsAppLoadE2E',
            getModuleContextMailboxInfo(),
            {
                timeout: PlacesMarkerTimeout,
            }
        );
    }

    protected getStepToWaterfallIndexMap(): typeof STEP_TO_WATERFALL_INDEX_MAP {
        return STEP_TO_WATERFALL_INDEX_MAP;
    }
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function PlacesAnalyticsAppLoadE2E called at module scope is not allowed. This may cause unwanted side effects. */
export const placesAnalyticsAppLoadE2E: PlacesAnalyticsAppLoadE2E = new PlacesAnalyticsAppLoadE2E();
